import React from 'react';
import { StatCard } from './controller/shared.tsx';

/** One glanceable KPI tile's data — thin wrapper around the existing `StatCard` props, keyed for `.map()`. */
export type KpiItem = {
  key: string;
  title: string;
  value: React.ReactNode;
  icon?: React.ReactNode;
  color?: string;
  subtitle?: string;
  delta?: number | null;
  deltaSuffix?: string;
  deltaDigits?: number;
  deltaInvert?: boolean;
  titleInfo?: React.ReactNode;
};

/**
 * The "always visible" KPI row at the top of every Feature 5.3 persona
 * dashboard (below the slicer bar, above the tabs) — 4-5 `StatCard`s in a
 * responsive grid. Kept intentionally dumb: each dashboard computes its own
 * KPI values from its already-loaded (and slicer-filtered) rows and passes
 * them in.
 */
export const KpiRow: React.FC<{ items: KpiItem[] }> = ({ items }) => {
  if (items.length === 0) return null;
  return (
    // Root-cause note (feedback round 2026-08-23): a fixed `grid-cols-N` per
    // breakpoint left orphan tiles whenever a band's item count didn't
    // divide evenly into that breakpoint's column count (e.g. 7 tiles on a
    // 5-column band -> a 2-tile second row). `analytics-kpi-grid` is the
    // shared `auto-fit`/`minmax` grid (see analytics.css) — the browser
    // computes the column count from available width, so any tile count
    // fills rows evenly at any viewport width instead of wrapping per a
    // hand-picked breakpoint table.
    <div className="analytics-kpi-grid mb-6 gap-4">
      {items.map(({ key, ...rest }) => (
        <StatCard key={key} {...rest} />
      ))}
    </div>
  );
};

export default KpiRow;
